var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h24v24H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.923 0 0 4.923 0 11s4.923 11 11 11 11-4.923 11-11S17.077 0 11 0zm0 19.871c-4.892 0-8.871-3.979-8.871-8.871S6.108 2.129 11 2.129 19.871 6.108 19.871 11 15.892 19.871 11 19.871zm-3.548-9.58c.785 0 1.419-.635 1.419-1.42 0-.785-.634-1.42-1.42-1.42-.784 0-1.419.635-1.419 1.42 0 .785.635 1.42 1.42 1.42zm7.096 0c.785 0 1.42-.635 1.42-1.42 0-.785-.635-1.42-1.42-1.42-.785 0-1.419.635-1.419 1.42 0 .785.634 1.42 1.42 1.42zm.178 3.22A4.84 4.84 0 0111 15.257a4.826 4.826 0 01-3.726-1.748 1.068 1.068 0 00-1.499-.137 1.067 1.067 0 00-.138 1.5A6.962 6.962 0 0011 17.382a6.962 6.962 0 005.363-2.51 1.063 1.063 0 00-.138-1.5 1.068 1.068 0 00-1.5.137z",
    fill: "#151A30"
  }))));
}

export default SvgSmile;